export default __webpack_public_path__ + "static/media/button_hover.b62290b0.mp3";